export default {
    namespaced: true,

    state: {
        list: false,
        daysLeft: 0,
        daysAdded: 0,
    },

    mutations: {
        SET(state, data) {
            state.list = data;
        },

        SET_DAYS_LEFT(state, data) {
            state.daysLeft = data;
        },

        DAYS_ADDED(state, data) {
            state.daysAdded = data;
        },
  },
}
